<span class="title truncate" [title]="title()">{{ title() }}</span>
<span class="value truncate" [title]="value()">{{ value() }}</span>
